import { useEffect } from "react";

export default function ProductSchema({ product }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-testid", "product-schema");
    script.textContent = JSON.stringify({ "@context": "https://schema.org", ...product });
    document.head.appendChild(script);
    return () => script.remove();
  }, [product]);
  return null;
}
